function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AnimatePresence, motion, useInView } from 'framer-motion';
import { v4 as uuidv4 } from 'uuid';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { useDebounce } from 'use-debounce';
import classNames from 'classnames';
import Icon, { IconSizes } from '../Icon';
import { Avatar, Text, Title } from '@mantine/core';
import styles from './ChatFilterPanels.module.scss';
import DocumentScan from '../icons/lord/DocumentScan';
import { LordIconSizes } from '@/types/client';
import useIntlMemo from '@/hooks/useIntlMemo';
function ChatterPanel(_param) {
    var messageScan = _param.messageScan, shouldStartScan = _param.shouldStartScan, props = _object_without_properties(_param, [
        "messageScan",
        "shouldStartScan"
    ]);
    var ref = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(false), 2), ready = _React_useState[0], setReady = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), shouldPlay = _React_useState1[0], setShouldPlay = _React_useState1[1];
    React.useEffect(function() {
        if (shouldStartScan) {
            setTimeout(function() {
                return setShouldPlay(true);
            }, 500);
        }
    }, [
        shouldStartScan
    ]);
    React.useEffect(function() {
        var currentRef = ref.current;
        if ((currentRef === null || currentRef === void 0 ? void 0 : currentRef.playFromBeginning) == null || !shouldPlay || !ready) {
            return;
        }
        currentRef.playFromBeginning();
    }, [
        shouldPlay,
        ref,
        ready
    ]);
    var _obj;
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: classNames(styles.chatterContainer, (_obj = {}, _define_property(_obj, styles.chatterContainerPositive, messageScan.positiveScanResult && shouldPlay), _define_property(_obj, styles.chatterContainerNegative, !messageScan.positiveScanResult && shouldPlay), _obj))
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Avatar, {
                radius: "md",
                size: "sm",
                color: "currentColor",
                className: styles.chatterAvatar,
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: faUser,
                    size: IconSizes.MD
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.chatterInfo,
                children: [
                    /*#__PURE__*/ _jsx(Title, {
                        order: 4,
                        children: "Chatter"
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        size: "xs",
                        className: styles.message,
                        children: messageScan.message
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.chatterScanIcon,
                children: /*#__PURE__*/ _jsx(DocumentScan, {
                    ref: ref,
                    onReady: function() {
                        return setReady(true);
                    },
                    size: LordIconSizes.MEDIUM,
                    state: messageScan.positiveScanResult ? 'morph-scan-OK' : 'morph-scan-WRONG'
                })
            })
        ]
    }));
}
var INTERVAL = 3000; // 3 seconds
export default function ChatFilterPanels(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var defaultChatterScans = useIntlMemo(function(intl) {
        return [
            {
                id: uuidv4(),
                message: intl.formatMessage({
                    id: "ErhTr6",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Hi! how are you?"
                        }
                    ]
                }),
                positiveScanResult: true
            },
            {
                id: uuidv4(),
                message: intl.formatMessage({
                    id: "WIzrHg",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "You are a "
                        },
                        {
                            children: [
                                {
                                    type: 0,
                                    value: "butthead"
                                }
                            ],
                            type: 8,
                            value: "badPhrase"
                        },
                        {
                            type: 0,
                            value: "!"
                        }
                    ]
                }, {
                    badPhrase: function(word) {
                        return /*#__PURE__*/ _jsx("span", {
                            className: styles.badPhrase,
                            children: word
                        });
                    }
                }),
                positiveScanResult: false
            },
            {
                id: uuidv4(),
                message: intl.formatMessage({
                    id: "0nf7TE",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "What a nice day!"
                        }
                    ]
                }),
                positiveScanResult: true
            }
        ];
    }, []);
    var _React_useState = _sliced_to_array(React.useState(defaultChatterScans), 2), messageScans = _React_useState[0], setMessageScans = _React_useState[1];
    var ref = React.useRef(null);
    var inView = useInView(ref);
    var _useDebounce = _sliced_to_array(useDebounce(inView, 500), 1), debouncedInView = _useDebounce[0];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), isVisible = _React_useState1[0], setIsVisible = _React_useState1[1];
    var cycleMessageScans = React.useCallback(function() {
        setMessageScans(function(prevMessageScans) {
            var _prevMessageScans = _to_array(prevMessageScans), first = _prevMessageScans[0], rest = _prevMessageScans.slice(1);
            var newLast = _object_spread_props(_object_spread({}, first), {
                id: uuidv4()
            });
            return _to_consumable_array(rest).concat([
                newLast
            ]);
        });
    }, [
        setMessageScans
    ]);
    React.useEffect(function() {
        if (!debouncedInView || !isVisible) {
            return;
        }
        var interval = setInterval(cycleMessageScans, INTERVAL);
        return function() {
            return clearInterval(interval);
        };
    }, [
        cycleMessageScans,
        debouncedInView,
        isVisible
    ]);
    React.useEffect(function() {
        var handleVisibilityChange = function() {
            return setIsVisible(document.visibilityState === 'visible');
        };
        handleVisibilityChange();
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function() {
            return document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    var center = Math.floor(messageScans.length / 2);
    if (messageScans.length % 2 === 0) {
        throw new Error('Message scans must be of odd length');
    }
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: ref,
        className: classNames(className, styles.messagePanelContainer)
    }, props), {
        children: /*#__PURE__*/ _jsx(AnimatePresence, {
            mode: "popLayout",
            initial: false,
            children: messageScans.map(function(messageScan, index) {
                var isCenter = index === center;
                var centerScale = isCenter ? 1 : 0.9;
                var centerFilter = !isCenter ? "brightness(0.2)" : 'brightness(1)';
                var shouldStartScan = index === center;
                return /*#__PURE__*/ _jsx(motion.div, {
                    layout: true,
                    style: {
                        position: 'absolute',
                        width: '100%',
                        zIndex: 1
                    },
                    initial: {
                        y: (index - center + 1) * 80,
                        scale: centerScale,
                        filter: centerFilter
                    },
                    animate: {
                        opacity: 1,
                        y: (index - center) * 80,
                        filter: centerFilter,
                        scale: centerScale
                    },
                    exit: {
                        y: (index - center - 1) * 80,
                        scale: centerScale,
                        filter: centerFilter
                    },
                    transition: {
                        duration: 2,
                        ease: 'easeInOut',
                        type: 'spring',
                        stiffness: 30,
                        damping: 10
                    },
                    children: /*#__PURE__*/ _jsx(ChatterPanel, {
                        messageScan: messageScan,
                        shouldStartScan: shouldStartScan
                    })
                }, messageScan.id);
            })
        })
    }));
}
